import React from "react";
import { useTranslation } from "react-i18next";
import HeroCardLayout from "../layout/HeroCardLayout";
import FloatingLabelInput from "../utils/FloatingLabelInput";
import "../../styles/components/entryflow/FinalizeCreateUser.css";

// Component for the "collect user info" state
interface Props {
  profilePictureUrl?: string;
  linkedInUrl: string;
  firstName: string;
  lastName: string;
  starting: boolean;
  statusMessage: string | null;
  requestLinkedIn: boolean;
  allowNameEditing: boolean;
  isSubmitDisabled?: boolean;
  botName?: string;
  onLinkedInUrlChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFirstNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onLastNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
}

const FinalizeCreateUserView: React.FC<Props> = ({
  profilePictureUrl,
  linkedInUrl,
  firstName,
  lastName,
  starting,
  statusMessage,
  requestLinkedIn,
  allowNameEditing,
  isSubmitDisabled,
  botName,
  onLinkedInUrlChange,
  onFirstNameChange,
  onLastNameChange,
  onSubmit,
}) => {
  const { t } = useTranslation();
  
  return (
    <>
      {profilePictureUrl && (
        <div className="completeuser-profile-picture-container">
          <img src={profilePictureUrl} alt={t("finalizeUser.profileAlt")} className="completeuser-profile-picture" />
        </div>
      )}
      <form className="completeuser-form" onSubmit={onSubmit}>
        <div className="completeuser-name-inputs-container">
          <FloatingLabelInput
            label={t("finalizeUser.firstName")}
            isName={true}
            limit={50}
            type="text"
            name="firstname"
            value={firstName}
            onChange={allowNameEditing ? onFirstNameChange : undefined}
            readOnly={!allowNameEditing}
            required
          />
          <FloatingLabelInput
            label={t("finalizeUser.lastName")}
            isName={true}
            limit={50}
            type="text"
            name="lastname"
            value={lastName}
            onChange={allowNameEditing ? onLastNameChange : undefined}
            readOnly={!allowNameEditing}
          />
        </div>
        {requestLinkedIn && (
          <>
            <div className="completeuser-linkedin-description">
              {t("finalizeUser.linkedInDescription", { botName: botName || "Bella" })}
            </div>
            <FloatingLabelInput
              label={t("finalizeUser.linkedInProfileUrl")}
              type="text"
              name="linkedinprofileurl"
              value={linkedInUrl}
              onChange={onLinkedInUrlChange}
              autoCapitalize="off"
              autoCorrect="off"
              isOptional={true}
            />
          </>
        )}
        {statusMessage && <div className="completeuser-status-message">{statusMessage}</div>}
        <button
          type="submit"
          className="entryflow-submit-button continue-button"
          disabled={isSubmitDisabled !== undefined ? isSubmitDisabled : starting}
        >
          {t("finalizeUser.continue")}
        </button>
      </form>
    </>
  );
};

const FinalizeCreateUserOnlyComponent: React.FC = () => {
  return (
    <HeroCardLayout>
      <div className="user-finalize-container">
        <FinalizeCreateUserView
          profilePictureUrl={"https://placecats.com/bella/300/300"}
          linkedInUrl={"linkedInUrl"}
          firstName={"First"}
          lastName={"Last"}
          starting={true}
          statusMessage={"Some status message"}
          requestLinkedIn={true}
          allowNameEditing={true}
          onLinkedInUrlChange={(e) => {}}
          onFirstNameChange={(e) => {}}
          onLastNameChange={(e) => {}}
          onSubmit={() => {}}
        />
      </div>
    </HeroCardLayout>
  );
};

export default FinalizeCreateUserView;
export { FinalizeCreateUserOnlyComponent };
